import {create} from "zustand";

export const useChangePassword = create((set, get) => ({
  passwordVisible: false,
  changePasswordModalVisible: false,
  isLoading: false,
  handleChangePasswordModal: () => {
    const changePasswordModalVisible = !get().changePasswordModalVisible;
    set({changePasswordModalVisible});
  },
  handlePasswordVisible: () => {
    const passwordVisible = !get().passwordVisible;
    set({passwordVisible});
  },
  changePassword: () => {
    set({changePasswordModalVisible: false});
    set({isLoading: false});
  },
}));

export const useInviteFriend = create((set, get) => ({
  inviteFriendModalVisible: false,
  isLoading: false,
  handleInviteFriendModal: () => {
    const inviteFriendModalVisible = !get().inviteFriendModalVisible;
    set({inviteFriendModalVisible});
  },
}));
